import clsx from 'clsx';
import { OrderVoucherType } from '@src/generated/graphql';
import { VOUCHER_CONFIGS } from '../../constants/vouchers';

interface Props {
  className?: string;
  type: OrderVoucherType;
}

function OrderVoucherIcon({ className, type }: Props): JSX.Element {
  const config = VOUCHER_CONFIGS[type];
  return (
    <div
      className={clsx(
        'flex h-12 w-12 items-center justify-center rounded-md',
        config.backgroundClass,
        config.iconClass,
        className,
      )}
    >
      <config.icon className="h-6 w-6" aria-hidden="true" />
    </div>
  );
}

export default OrderVoucherIcon;
